/**
 * Registers the widget's fonts (Geist, Geist Mono) on the host document.
 *
 * The bytes are inlined at build time (build.mjs) and handed to the FontFace
 * API as an ArrayBuffer — nothing is fetched, so a host CSP without `data:`
 * in font-src cannot block them. Faces on `document.fonts` are visible inside
 * the widget's closed shadow root; an @font-face rule in the shadow styles
 * would not be. The family names are prefixed so they never collide with the
 * host page's own fonts. Any failure leaves the system font stack in place.
 */
declare const __GEIST_BASE64__: string;
declare const __GEIST_MONO_BASE64__: string;

let registered = false;

function bytes(base64: string): ArrayBuffer {
  const bin = atob(base64);
  const out = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) out[i] = bin.charCodeAt(i);
  return out.buffer;
}

export function registerFonts(): void {
  if (registered || typeof FontFace === 'undefined' || !document.fonts) return;
  registered = true;
  const faces: Array<[string, string]> = [
    ['Klientele Geist', __GEIST_BASE64__],
    ['Klientele Geist Mono', __GEIST_MONO_BASE64__],
  ];
  for (const [family, data] of faces) {
    try {
      const face = new FontFace(family, bytes(data), { weight: '100 900', style: 'normal', display: 'swap' });
      document.fonts.add(face);
      void face.load().catch(() => document.fonts.delete(face));
    } catch {
      /* system fonts take over */
    }
  }
}
